module.exports = __webpack_public_path__ + "397a78aacf819bb2c077a47e5b54aa28.pdf";